<div class="clearfix">
  <h4 class="float-left">{{ stat.caption }} ({{ stat.n }})</h4>
  <button type="button" class="btn btn-secondary float-right" (click)="onExcel()">Excel</button>
</div>
<div class="table-responsive">
<table class="table table-sm mt-2">
  <thead>
    <tr>
      <th scope="col" style="width: auto">#</th>
      <th scope="col" style="width: 32px"></th>
      <th scope="col" [tableSort]="stat.data" data-order="" data-name="key">{{ categoryName }}</th>
      <th scope="col" [tableSort]="stat.data" data-order="" data-name="value">Кол-во</th>
      <th scope="col" [tableSort]="stat.data" data-order="" data-name="percent">%</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of stat.data; let idx = index">
      <th scope="row" style="width: auto">{{ idx + 1 }}</th>
      <td style="width: 32px"><p-button *ngIf="isCanEdit" label="Ред." [style]="{ 'padding': '0px' }" styleClass="p-button-link p-button-sm" (click)="onReplace(item.key)"></p-button></td>
      <td>{{ item.key }}</td>
      <td>{{ item.value }}</td>
      <td>{{ item.percent }}</td>
    </tr>
    <tr class="table-active">
      <th scope="row" style="width: auto"></th>
      <td style="width: 32px"></td>
      <td>ИТОГО</td>
      <td>{{ stat.n }}</td>
      <td>100</td>
    </tr>
  </tbody>
</table>
</div>
